import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
export let analyticsLogger;
export function setupAnalytics() {
    const firebaseConfig = {
        apiKey: "AIzaSyCEhtMXtlrkqCZt_5gfekZ3YIq_euqwh_E",
        authDomain: "thetranslit.firebaseapp.com",
        databaseURL: "https://thetranslit.firebaseio.com",
        projectId: "thetranslit",
        storageBucket: "thetranslit.appspot.com",
        messagingSenderId: "1058911688567",
        appId: "1:1058911688567:web:84d546a0b8605ee3327372",
        measurementId: "G-LXNVE7L7EP"
    };
    initializeApp(firebaseConfig);
    setAnalyticsLogger(getAnalytics());
}
export function setAnalyticsLogger(logger) {
    analyticsLogger = logger;
}
export function logEvent(name, event) {
    analyticsLogger.logEvent(name, event);
}
